// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category__tile--hover[data-v-5ce916e8]{background:var(--v-primary-base)!important;opacity:.8}.v-card--reveal[data-v-5ce916e8]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;bottom:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;width:100%}", ""]);
// Exports
module.exports = exports;
